module.exports = __webpack_public_path__ + "power.mp3?bb3246ecb0d8aedabaae4e24a670c730";


//////////////////
// WEBPACK FOOTER
// ./src/kits/1/sounds/power.mp3
// module id = 481
// module chunks = 0